import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Testimonials } from "@/components/site/Testimonials";
import { Gallery } from "@/components/site/Gallery";
import { FinalCta, Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div data-testid="app-container" className="bg-navy min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <WhyUs />
                <BeforeAfter />
                <Testimonials />
                <Gallery />
                <FinalCta />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
